import React from 'react'
import styles from './Pricing.module.css';
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';
import ProjectServices from '../../services/projectServices';
import { message } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getTranslation } from '../../util/utilFunc';

const pricingPlans = [
    {
        name: "Freemium Plan",
        price: "£0",
        period: "/month",
        features: [
            { label: "For", value: "Individuals and small teams exploring Compelion" },
            { label: "Users", value: "1 user + 1 collaborator" },
            { label: "Projects", value: "Manage up to 2 project types per month" },
            { label: "AiFeatures", value: "Limited assistance for task organisation" },
            { label: "Integrations", value: "None" },
            { label: "Support", value: "Email only" },
            { label: "Customisation", value: "Currently Not supporting" },
        ],
        buttonText: "Subscribe Now",
    },
    {
        name: "Team Plan",
        price: "£30",
        period: "/user/month",
        features: [
            { label: "For", value: "Small to medium-sized teams" },
            { label: "Users", value: "Up to 100 users" },
            { label: "Projects", value: "Unlimited" },
            { label: "AiFeatures", value: "Full AI-powered tools for idea management" },
            { label: "Integrations", value: "Seamless with Google Workspace and Microsoft 365" },
            { label: "Support", value: "Priority email and chat" },
            { label: "Customisation", value: "Limited" },
        ],
        buttonText: "Subscribe Now",
        popular: true,
    },
    {
        name: "Growth Plan",
        price: "£25",
        period: "/user/month",
        features: [
            { label: "For", value: "Growing organisations" },
            { label: "Users", value: "Up to 500 users" },
            { label: "Projects", value: "Unlimited" },
            { label: "AiFeatures", value: "Advanced AI with analytics and recommendations" },
            { label: "Integrations", value: "Enhanced tools for Google Workspace and Microsoft 365" },
            { label: "Support", value: "Dedicated success manager" },
            { label: "Customisation", value: "Limited" },
        ],
        buttonText: "Subscribe Now",
    },
    {
        name: "Enterprise Plan",
        price: "Contact Us",
        period: "",
        features: [
            { label: "For", value: "Large enterprises" },
            { label: "Users", value: "Unlimited" },
            { label: "Projects", value: "Unlimited" },
            { label: "AiFeatures", value: "Tailored AI solutions with deep analytics" },
            { label: "Integrations", value: "Enterprise-grade Google Workspace and Microsoft 365" },
            { label: "Support", value: "24/7 with a dedicated account manager" },
            { label: "Customisation", value: "Full workflow and system integration" },
        ],
        buttonText: "Subscribe Now",
    },
]

const pricingPlansArabic = [
    {
        name: "الخطة المجانية",
        price: "£0",
        period: "/شهر",
        features: [
            { label: "مناسبة لـ", value: "الأفراد والفرق الصغيرة التي تستكشف Compelion" },
            { label: "عدد المستخدمين", value: "مستخدم واحد + متعاون واحد" },
            { label: "المشاريع", value: "إدارة ما يصل إلى نوعين من المشاريع شهريًا" },
            { label: "ميزات الذكاء الاصطناعي", value: "مساعدة محدودة لتنظيم المهام" },
            { label: "التكاملات", value: "لا يوجد" },
            { label: "الدعم", value: "عبر البريد الإلكتروني فقط" },
            { label: "التخصيص", value: "غير مدعوم حاليًا" },
        ],
        buttonText: "اشترك الآن",
    },
    {
        name: "خطة الفريق",
        price: "£30",
        period: "/مستخدم/شهر",
        features: [
            { label: "مناسبة لـ", value: "الفرق الصغيرة إلى المتوسطة" },
            { label: "عدد المستخدمين", value: "حتى 100 مستخدم" },
            { label: "المشاريع", value: "غير محدودة" },
            { label: "ميزات الذكاء الاصطناعي", value: "أدوات كاملة مدعومة بالذكاء الاصطناعي لإدارة الأفكار" },
            { label: "التكاملات", value: "تكامل سلس مع Google Workspace وMicrosoft 365" },
            { label: "الدعم", value: "أولوية عبر البريد الإلكتروني والدردشة" },
            { label: "التخصيص", value: "محدود" },
        ],
        buttonText: "اشترك الآن",
        popular: true,
    },
    {
        name: "خطة النمو",
        price: "£25",
        period: "/مستخدم/شهر",
        features: [
            { label: "مناسبة لـ", value: "المؤسسات النامية" },
            { label: "عدد المستخدمين", value: "حتى 500 مستخدم" },
            { label: "المشاريع", value: "غير محدودة" },
            { label: "ميزات الذكاء الاصطناعي", value: "ذكاء اصطناعي متقدم مع تحليلات وتوصيات" },
            { label: "التكاملات", value: "أدوات معززة لـ Google Workspace وMicrosoft 365" },
            { label: "الدعم", value: "مدير نجاح مخصص" },
            { label: "التخصيص", value: "محدود" },
        ],
        buttonText: "اشترك الآن",
    },
    {
        name: "خطة المؤسسة",
        price: "اتصل بنا",
        period: "",
        features: [
            { label: "مناسبة لـ", value: "المؤسسات الكبيرة" },
            { label: "عدد المستخدمين", value: "غير محدود" },
            { label: "المشاريع", value: "غير محدودة" },
            { label: "ميزات الذكاء الاصطناعي", value: "حلول ذكاء اصطناعي مخصصة مع تحليلات عميقة" },
            { label: "التكاملات", value: "تكامل على مستوى المؤسسات مع Google Workspace وMicrosoft 365" },
            { label: "الدعم", value: "24/7 مع مدير حساب مخصص" },
            { label: "التخصيص", value: "تخصيص كامل لخطوات العمل وتكامل الأنظمة" },
        ],
        buttonText: "اشترك الآن",
    },
]



const Pricing = () => {
    const navigate = useNavigate();
    const { userInfo, language } = useSelector(state => state.auth);

    const handlePayment = async (plan) => {

        var mainPlan = plan;
        if (plan === "الخطة المجانية") {
            mainPlan = "Freemium Plan"
        }
        else if (plan === "خطة الفريق") {
            mainPlan = "Team Plan"
        }
        else if (plan === "خطة النمو") {
            mainPlan = "Growth Plan"
        }
        else if (plan === "خطة المؤسسة") {
            mainPlan = "Enterprise Plan"
        }

        if (!userInfo) {
            return navigate("/login");
        }

        try {
            if (language === "ar") {
                plan = plan === "الخطة المجانية" ? "Freemium Plan" : plan === "خطة الفريق" ? "Team Plan" : plan === "خطة النمو" ? "Growth Plan" : "Enterprise Plan";
            }
            // Make a request to your backend to create a Checkout Session
            const getUserResponse = await ProjectServices.userCheckoutSession({
                stripe_price_id: mainPlan,
            });

            if (!getUserResponse || getUserResponse.status !== 200) {
                message.error(getTranslation("Failed to create checkout session", language));
                return;
            }

            const { url } = getUserResponse.data;

            if (!url) {
                message.error(getTranslation("Failed to retrieve the Stripe checkout URL", language));
                return;
            }

            // Redirect to the Stripe Checkout page
            window.location.href = url;
        } catch (error) {
            console.error("Error creating checkout session:", error);
            message.error(getTranslation("Payment process failed", language));
        }
    };


    let pricingPlansWithTranslation = pricingPlans;

    if (language === "ar") {
        pricingPlansWithTranslation = pricingPlansArabic;
    }

    return (
        <div>
            <Navbar />
            <div className={styles.contact__wrapper}>
                <h1>{getTranslation("Choose the right plan for your team", language)}</h1>
            </div>
            <div className={styles.container}>

                <div className={styles.grid}>
                    {pricingPlansWithTranslation.map((plan, index) => (
                        <div
                            key={index}
                            className={`${styles.card} ${plan.popular ? styles.popular : ''}`}
                        >
                            <div className={styles.header}>
                                <div className={styles.name}>{plan.name}</div>
                                <div className={styles.price}>
                                    {plan.price}
                                    <span className={styles.period}>{plan.period}</span>
                                </div>
                            </div>

                            <div className={styles.features}>
                                {/* Vertical Line */}
                                <div className={styles.verticalLine}></div>
                                {plan.features.map((feature, featureIndex) => (
                                    <div key={featureIndex} className={styles.feature}>
                                        <span className={styles.featureLabel}>{feature.label}</span>
                                        <span className={styles.featureValue}>{feature.value}</span>
                                    </div>
                                ))}
                            </div>


                            <button className={styles.button} onClick={() => handlePayment(plan.name)}>
                                {plan.buttonText}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Pricing